// Generated by GitHub Copilot
import React from 'react';
import styles from './Footer.module.css';

const FOOTER_LINKS = [
  { label: 'Privacy Policy', href: 'https://www.accenture.com/gb-en/support/privacy-policy' },
  // { label: 'Cookie Policy', href: '#cookies' },
  { label: 'Terms of Use', href: 'https://www.accenture.com/us-en/support/terms-of-use' },
];

/**
 * Site-wide footer with legal links and copyright notice.
 * Uses semantic <footer> and <nav> for accessibility.
 */
const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      {/* Legal links */}
      <nav aria-label="Footer legal links">
        <ul className={styles.navList}>
          {FOOTER_LINKS.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                className={styles.navLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      {/* Copyright */}
      <p className={styles.copyright}>
        Copyright 2001-{year} Accenture. All rights reserved. Accenture Confidential. For internal use only.
      </p>
    </footer>
  );
};

export default Footer;
